require('@rails/ujs').start();

import '@fortawesome/fontawesome-free/js/all';

require('../style/search');
require('../style/application');

